// extracted by mini-css-extract-plugin
export default {"unsplashImgs":"RoyalImages_unsplashImgs__xZClo","active":"RoyalImages_active__EWT+J"};